var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBovinosLeite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(12040 555)",
    fill: "#36364a",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12040 -555)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12036.017 545.008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,13.637a18.45,18.45,0,0,1-.27,2.565c.81.27,1.62.405,2.3.675a1.021,1.021,0,0,1,.54.135c.405,0,.54.27.54.675s-.405.54-.81.405a6.087,6.087,0,0,1-1.485-.405,4.291,4.291,0,0,1-1.215-.405,9.117,9.117,0,0,1-.27,1.89H32.54a.716.716,0,0,1,.81.81v1.35a.812.812,0,0,1-.135.54c-.405.54-.54.945,0,1.485a18.152,18.152,0,0,1,1.485,1.89,2.851,2.851,0,0,1,.54,1.35V39.426a2.409,2.409,0,0,1-2.565,2.565H28.624a2.429,2.429,0,0,1-2.025-.945,1.031,1.031,0,0,0-.675-.27H9.046c-1.08,0-1.215,0-1.08-1.08,0-2.97-.405-5.806-.675-8.776-.405-3.916-.81-7.831-1.35-11.747-.135-1.755-.405-3.511-.54-5.266,0-.135-.27-.27-.27-.405-.135-.27-.405-.405-.405-.675v-2.16A.638.638,0,0,1,5.4,9.992H32.27c.945,0,1.08,0,1.08,1.08v1.485c0,.54,0,.945-.81.945ZM8.776,37.536H25.924V26.869a2.031,2.031,0,0,1,.54-1.485l1.62-2.025a1.226,1.226,0,0,0,0-1.35,1.979,1.979,0,0,1-.27-.54V19.983a.716.716,0,0,1,.81-.81h1.89a13.3,13.3,0,0,1,.27-2.3l-9.722-2.835a2.471,2.471,0,0,1-2.565,1.62c-1.215-.135-1.755-.945-2.025-2.16H6.481c.945,7.966,1.755,15.932,2.7,23.9ZM33.89,37H31.865c-.54,0-.81-.135-.81-.81V29.3c0-.675.135-.81.81-.81H33.89c0-.945.27-1.89-.54-2.7-.54-.54-.945-1.485-1.485-1.755a6.554,6.554,0,0,0-2.3,0,1.031,1.031,0,0,0-.675.27,8.668,8.668,0,0,0-1.35,1.755,2.859,2.859,0,0,0-.405.945V39.7c0,.81.405,1.35,1.215,1.35H32.81a1.3,1.3,0,0,0,1.215-1.08V37.131ZM19.578,13.907c-.405-.135-.945-.135-1.215-.405-.135,0-.405-.54-.405-.675s.405-.405.675-.405.405.135.675.135h.405c.27,0,.54-.135.81-.135H31.46v-1.08H5.4v1.08H16.2c.945,0,1.215,0,1.215,1.08a1.3,1.3,0,0,0,.945,1.215,1.261,1.261,0,0,0,1.35-.675Zm6.346,24.844H8.776v1.08H25.789v-1.08ZM32.27,29.57v6.211h1.62V29.57ZM22.954,13.637h0c2.565.675,5,1.485,7.561,2.16a13.3,13.3,0,0,1,.27-2.3H22.954Zm5.806,7.291h2.97c.405,0,.27-.27.27-.54H28.624v.54Zm.54,1.755h2.3v-.54h-2.16v.54Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8,31.46c-1.08,0-1.08-.945,0-1.215,1.215,0,1.35,1.08.135,1.215H15.8Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.633,31.46c-.675,0-1.215-.675-.405-1.08.405-.135,1.215,0,1.35.405,0,.405-.54.54-.81.54h0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.287,25.384l-2.025-.81a.563.563,0,0,1,0-1.08,18.033,18.033,0,0,1,2.43-.945v-2.3a.9.9,0,0,1,.54-.675,1.8,1.8,0,0,1,.675.405,4.044,4.044,0,0,0,1.62,2.025,2.5,2.5,0,0,0,.945.27h1.08a2.727,2.727,0,0,0,2.7-1.485,3.384,3.384,0,0,1,.54-.945c0-.135.405-.405.54-.405s.405.27.54.54v2.43a18.032,18.032,0,0,1,2.43.945c.27,0,.54.405.54.675,0,.135-.27.54-.54.54-.675.27-1.35.54-1.89.81a16.325,16.325,0,0,0-.675,2.43,15.218,15.218,0,0,0-.405,2.43,2.109,2.109,0,0,1-1.08,2.025,5.85,5.85,0,0,1-5.941,0,2.009,2.009,0,0,1-.945-2.025,5.573,5.573,0,0,0-.54-2.97,13.854,13.854,0,0,1-.54-1.89Zm2.16,3.241a6.025,6.025,0,0,1,5.671,0l.81-2.025A2.24,2.24,0,0,0,18.9,23.494H15.8a2.311,2.311,0,0,0-2.025,3.241l.81,2.025ZM17.283,32a3.535,3.535,0,0,0,2.3-.675c.675-.54.675-.945,0-1.485a4.293,4.293,0,0,0-4.726,0c-.675.54-.675,1.08,0,1.485A3.686,3.686,0,0,0,17.283,32Zm5.536-7.966V23.9a3.942,3.942,0,0,1-1.215-.27c.27.81.81.405,1.215.405ZM11.882,23.9c.405.27.945.54,1.08-.27A3.178,3.178,0,0,0,11.882,23.9Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.675,
    cy: 0.675,
    r: 0.675,
    transform: "translate(15.392 24.574)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.675,
    cy: 0.675,
    r: 0.675,
    transform: "translate(17.688 24.574)",
    fill: "#36364a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBovinosLeite);
export default __webpack_public_path__ + "static/media/bovinos_leite.dff474e13f8b63991d1f363cabd3abee.svg";
export { ForwardRef as ReactComponent };